
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Divider, Pagination, Input } from "antd";

import CreateJobsReport from './EachActiveJobs/eachActiveJobs';

import "./activeJobs.scss";
class ActiveJobsList extends Component{
    constructor(props) {
        super(props)

        let activeJobsReportList=[
            {
                name:'lucy@gmail.com',
                jobStart: '3/3/20, 3:80 pm',
                jobType: 'AWS Migration',
                source: 'wasabi-rick',
                destination: 'aws',
                percentage: '63 TB',
                action: 'Pause'
            },
            {
                name:'john@yahoo.com',
                jobStart: '11/12/20, 2:40 am',
                jobType: 'AWS Migration',
                source: 'wasabi-rick',
                destination: 'aws',
                percentage: '63 TB',
                action: 'Resume'
            },
            {
                name:'z@gmail.com',
                jobStart: '5/20/19, 4:00 pm',
                jobType: 'AWS Migration',
                source: 'wasabi-rick',
                destination: 'aws',
                percentage: '63 TB',
                action: 'Pause'
            },
            {
                name:'bob@gmail.com',
                jobStart: '5/20/19, 4:00 pm',
                jobType: 'AWS Migration',
                source: 'wasabi-rick',
                destination: 'aws',
                percentage: '63 TB',
                action: 'Resume'
            },
            {
                name:'Juli@yahoo.com',
                jobStart: '11/12/20, 2:40 am',
                jobType: 'AWS Migration',
                source: 'wasabi-rick',
                destination: 'aws',
                percentage: '63 TB',
                action: 'Resume'
            },

        ];
        this.state = {
            activeJobsReport: activeJobsReportList,
            search: '',
        };

    }

    updateSearch(event){
        this.setState({search: event.target.value.substr(0, 20)});
    }

    render(){
        const jobsReportTableHeader = <ul>
                                        <li>User Name</li>
                                        <li>Job Start</li>
                                        <li>Job Type</li>
                                        <li>Source account</li>
                                        <li>Destination</li>
                                        <li>Transfered</li>
                                        <li>Action</li>
                                    </ul>
        
        let filterContacts = this.state.activeJobsReport.filter(
            (contact) => {
                return contact.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1;
            }
        );

        const ReportList = filterContacts.map((rl,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateJobsReport 
                        key = {index}
                        name = {rl.name}
                        jobStart = {rl.jobStart}
                        jobType = {rl.jobType}
                        source = {rl.source}
                        destination = {rl.destination}
                        percentage = {rl.percentage}
                        action = {rl.action}
                    />
                </div>
            )
        })
        return(
            <div className="active-jobs-wrapper">
                <div className="header">
                    <h3>Active Jobs</h3>
                    <Input 
                        className="search-input"
                        placeholder="Search Users or Account Name"
                        type="text"
                        value={this.state.search} 
                        onChange={this.updateSearch.bind(this)}
                        name="" 
                        id=""
                    />

                    {/* <Input
                        className="search-input"
                        placeholder="Search ... "
                        // prefix={
                        //     (searchKeyword === '' || !visibleSearch) && (
                        //     <Icon type="search" />
                        //     )
                        // }
                        // suffix={
                        //     searchKeyword !== '' &&
                        //     visibleSearch && <Icon type={loading ? 'loading' : 'search'} />
                        // }
                        // value={searchKeyword}
                        onChange={this.onSearch}
                    /> */}
                </div>
                <div className="table-header">
                    {jobsReportTableHeader}
                </div>
                <div>
                    {ReportList}
                </div>
                <Divider/>
                <div className="page-pagination">
                    <Pagination size="small" total={500} defaultPageSize={10}/>

                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(ActiveJobsList)
  );